import { PlusCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';

import { emptyFn } from '@app/constants';
import { useNewUserAccessRights } from '@app/hooks';
import type { NFunnels } from '@app/types';
import { getContrastYIQ } from '@app/utils';

const defaultBackgroundColor = '#19b2ff';
const defaultColor = 'black';

type Chevron = {
  stage: NFunnels.SalesFunnelStageFilterListDto;
  rectangleWidth: number;
  setCurrentSalesFunnelStage: (
    value: NFunnels.SalesFunnelStageFilterListDto | undefined
  ) => void;
  handleOpenSalesFunnelModal: (id: number, isEditModal: boolean) => void;
  salesFunnelId: number;
};

export const Chevron: React.FC<Chevron> = ({
  stage,
  rectangleWidth,
  setCurrentSalesFunnelStage,
  handleOpenSalesFunnelModal,
  salesFunnelId,
}) => {
  const { Color, Name } = stage;

  const {
    userAccessRights: {
      SalesFunnels: { IsStageCreate, IsStageEdit },
    },
  } = useNewUserAccessRights();

  const handleChevronIconClick = () => {
    setCurrentSalesFunnelStage(stage);
    handleOpenSalesFunnelModal(salesFunnelId, true);
  };

  const handleAddIconClick = () => {
    setCurrentSalesFunnelStage(stage);
    handleOpenSalesFunnelModal(salesFunnelId, false);
  };

  if (!Name) {
    return;
  }

  return (
    <div className="chevron-component-container">
      <div
        className="chevron"
        onClick={IsStageEdit ? handleChevronIconClick : emptyFn}
      >
        <div
          className="rectangle"
          style={{
            color: Color ? getContrastYIQ(Color) : defaultColor,
            backgroundColor: Color ? Color : defaultBackgroundColor,
            width: `${rectangleWidth}px`,
          }}
        >
          {Name}
        </div>
        <div
          className="triangle"
          style={{ backgroundColor: Color ? Color : defaultBackgroundColor }}
        />
      </div>

      {IsStageCreate && (
        <div className="icon-container" onClick={handleAddIconClick}>
          <Tooltip title={'Добавить этап воронки'}>
            <PlusCircleOutlined className="add-icon" />
          </Tooltip>
        </div>
      )}
    </div>
  );
};
